<template>
  <div class="mb-4">
    <div class="rounded-lg w-full border-1 border-solid border-border p-base flex justify-center bg-whiteOverride text-center mb-base">
      <p class="text-black text-24" data-test="recovery-code" v-if="displayCode">{{ code }}</p>
      <p v-else class="placeholder" data-test="recovery-code-placeholder">--------------------</p>
    </div>
    <slot name="button" :copyRecoveryCode="copyRecoveryCode">
      <button
          type="button"
          class="tw-button tw-button-cta"
          data-ec="recovery_code"
          data-et="btn_copy"
          v-if="displayCode"
          @click="copyRecoveryCode"
          data-test="copy-recovery-code"
      >
        <span>{{ $t('mfa.copyCode') }}</span>
      </button>
    </slot>
  </div>
</template>

<script>

export default {
  name: 'RecoveryCode',

  props: {
    code: {
      type: String,
      default: null,
    },
  },

  computed: {
    displayCode() {
      return !!this.code;
    },
  },

  methods: {
    copyRecoveryCode() {
      navigator.clipboard.writeText(this.code).then(() => {
        this.$bus.$emit('renderGlobalMessage', ({
          message: this.$t('mfa.recoveryCodeCopiedToClipboard'),
          icon: 'check',
          type: 'success',
        }));
      });
    },
  },
};
</script>

<style scoped>
.tw-button-small svg {
  margin: 0;
}

.placeholder {
  letter-spacing: 5px;
  @apply
    text-24
    text-disabledGrey
}

</style>
